import { createFileRoute } from '@tanstack/react-router'
import ProjectInspectionsPage from '@/spa/pages/projects/ProjectInspectionsPage'
import { routeErrorComponent } from '../../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/inspections/')({
  component: ProjectInspectionsPage,
  errorComponent: routeErrorComponent,
})
